import React, { Component } from 'react'
import ReactPlayer from 'react-player';
import { Grid, Box, Container, Typography, Pagination } from '@mui/material'
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import AudioPlayer from 'react-h5-audio-player'
import 'react-h5-audio-player/lib/styles.css';


let Sound = (data)=>{
  if (!(data && data.item)) return;

  return (
    <Box sx={{ width:'auto', maxWidth:'500px', margin:'2rem auto' }}>
      <AudioPlayer
        src={ data.item }
        autoPlay={false}
        autoPlayAfterSrcChange={false}
        layout='stacked'
        preload='metadata'
      />
    </Box>
  )
}

let Movie = (data)=>{
  if (!(data && data.item)) return;

  return (
    <Box p='1rem 0' sx={{ 'div':{margin:'auto'} }}>
      <ReactPlayer
        style={{ maxWidth:'100%', height:'auto' }}
        controls
        url={ data.item }
      />
    </Box>
  )
}

let File = (data)=>{
  if (!(data && data.item)) return;

  return (
    <Box p='1rem 0' sx={{ 'div':{margin:'auto'} }}>
      <a href={ data.item }>
        {/* { data.item } */}
        [ 添付ファイルをダウンロード ]
        <DownloadForOfflineIcon  style={{ verticalAlign:'middle',marginLeft:'10px' }} variant='primary' fontSize='large'/>
      </a>
    </Box>
  )
}

let text_to_link = (text)=> {
  let regexp_url = /((h?)(ttps?:\/\/[a-zA-Z0-9.\-_@:/~?%&;=+#',()*!]+))/g;
  let regexp_makeLink = function(all, url, h, href) {
    return '<a href="h' + href + '" target="_blank">' + url + '</a>';
  }

  return text.replace(regexp_url, regexp_makeLink)
}

let MultiLineBody = ({body})=>{
  body = text_to_link(body)

  let texts = body.split(/\r\n|\n/).map((item, index)=>{
    return (
      <React.Fragment key={index}>
        {/* {item} */}
        <span dangerouslySetInnerHTML={{__html:item}} />
        <br />
      </React.Fragment>
    )
  })

  return <>{texts}</>
}

export { Sound, Movie, File, MultiLineBody }
